var map = {
	"./akx.mp3": "810d",
	"./als.mp3": "4986",
	"./bz.mp3": "3047",
	"./fes.mp3": "7729",
	"./hh.mp3": "9513",
	"./lfe.mp3": "09f4",
	"./ll.mp3": "2307",
	"./llt.mp3": "e706",
	"./lsl.mp3": "527a",
	"./mets.mp3": "327e",
	"./tgre.mp3": "189e",
	"./xm.mp3": "f3dc",
	"./ydl.mp3": "6f19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "39cb";